import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// Working Hours Component
import WorkingHours from '../../WorkingHours/index';

const Container = styled.div`
  width: min-content;
`;

const ProfileTab = () => {
  const { data = {} } = usePageData();

 
  return (
    <Container>
      <WorkingHours stylist_id={data.stylist_id} />
    </Container>
  );

};

export default ProfileTab;